import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import DischargeDemo from '../components/DischargeDemo';

function DischargeDemoPage() {
  return (
    <>
      <PageHero
        label="Nexus Health"
        title="Discharge Coordination Demo"
        subtitle="AI-powered discharge planning built on Neurochemical Conductance Architecture. Every decision auditable. Every step CMS-compliant. Runs on a tablet at the bedside."
      />
      <BackButton />
      <DischargeDemo />
    </>
  );
}

export default DischargeDemoPage;
